<template>     
   <nav v-if="business" class="w3-sidebar w3-bar-block w3-card w3-hide-large" id="mySidebar" style="display:none;z-index:999">
      <div class="w3-container w3-theme-d2">
        <large-button @click="click('closesidebar')" class="w3-display-topright">X</large-button>        
        <div  class="w3-padding w3-center">
          <img class="w3-circle" :src="business.favi" alt="logo" style="width:60px">
        </div>        
        <div v-if="person" class="w3-padding w3-center">
          {{person.displayName}}
        </div>
      </div>
      <div @click="click('closesidebar')" v-if="business">
        <router-link class="w3-bar-item w3-button" to="/admin/customerremedials/processing">Remedials</router-link> 
               
        <router-link v-if="alladminrights && Object.keys(alladminrights).length>=1" class="w3-bar-item w3-button" to="/businessselect">Shops</router-link>
        <router-link v-if="business.pwa" class="w3-bar-item w3-button" to="/">{{business.pwa.menus.home}}</router-link>        
       
        <router-link v-if="business.pwa" class="w3-bar-item w3-button" to="/about">{{business.pwa.menus.about}}</router-link> 
        
        <!-- <router-link v-if="personorders && personorders.length>0" class="w3-bar-item w3-button" to="/orders">Orders</router-link>       
        <router-link v-if="business && !business.hideaccountlink  && person && person.id" class="w3-bar-item w3-button" to="/account">Accounts</router-link>  -->
                         
        
        <router-link v-if="adminrights && (adminrights.read || adminrights.write)" class="w3-bar-item w3-button" to="/admin/home">Admin</router-link> 
        <!-- <router-link v-if="adminrights && adminrights.custorderprocess" class="w3-bar-item w3-button" to="/admin/customerorders/home">Cust Orders</router-link>  -->

        <br>
         
        <router-link v-if="profile" class="w3-bar-item w3-button" to="/profile">Profile</router-link>        
        <router-link v-if="!person" class="w3-bar-item w3-button" to="/login">Login</router-link>                        
        <a href="#" v-else class="w3-bar-item w3-button" @click="click('logout');$router.push('home')">Logout</a>
        
        <!-- <router-link v-if="business && !business.hidehelp" class="w3-bar-item w3-button" to="/how">How To</router-link>  -->
        <router-link class="w3-bar-item w3-button" to="/wpp">Privacy</router-link>
        <a href="#" class="w3-bar-item w3-button" @click="click('unregister')">Refresh</a>

      </div> 
      
    </nav>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
export default {    
  
  data: function() {
      return {}
  },
  methods: {
    click(action){
       this.$emit("click", {
          action: action
      });      
    }
  },      
  computed: {      
    ...mapGetters(["business", "person","personorders","adminrights",
    "alladminrights","profile"])
  }
};
</script>
 
<style>
  
</style>



// WEBPACK FOOTER //
// src/components/app/SideNavLayout.vue